import React from "react";
import {connect} from "react-redux";
import {busquedaActions} from "../../_actions/busqueda.actions";
import queryString from "query-string";
import { NumericFormat as NumberFormat } from "react-number-format";
import {productoActions} from "../../_actions";
import cartService from "../../_services/cart/cart.service";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {actualizarMetaTags, LoaderGeneral, nombreVendedor, restaurarMetaTags, TIPO_ENVIO, TIPO_REPUESTO, urlCategoria} from "../../_helpers";
import productoServiceTs from "../../_services/cart/producto.service";
import {Modal} from "react-bootstrap";
import {LoginPage} from "../general";
import authService from "../../_services/cart/authService";
import CarrouselProductosRel from "./utils/CarrouselProductosRel";
import {Link} from "react-router-dom";
import CarrouselImages from "./utils/CarrouselImages";
import alertService from "../../_services/cart/alert.service";
import {ModalWhatsappVendedor} from "./utils/ModalWhatsappVendedor";
import {AlertaModal} from "./utils/AlertaModal";
import vendedorService from "../../_services/cart/vendedor.service";
import chatService from "../../_services/cart/chat.service";
import {history} from "../../_helpers";
import { BadgeOferta, CartelOferta, PrecioTachado, precioVigente } from "./utils/Oferta";

class ProductDetail extends React.Component {
    state = {
        appName: process.env.PUBLIC_URL,
        showLogin: false,
        loading: false,
        cantidad: 1,
        repuestosBaja: [],
        otrosProductosVendedor: [],
        productosSimilares: [],
        showWhatsapp: false,
        showAlerta: false,
        contactosPrecargados: false,
    };

    constructor() {
        super();
        window.scrollTo(0, 0);
    }

    componentDidMount() {
        this.refreshProducto();
        // Si el producto ya venia en el store (volver atras), componentDidUpdate no se
        // dispara y la precarga tiene que salir igual.
        this.precargarContactos();
    }

    componentDidUpdate(prevProps) {
        // Los carruseles de "relacionados" navegan a otra ficha sin desmontar el
        // componente: hay que volver a pedir el producto y reescribir los metadatos.
        if (prevProps.location?.pathname !== this.props.location?.pathname ||
            prevProps.location?.search !== this.props.location?.search) {
            this.refreshProducto();
        }

        if (prevProps.producto !== this.props.producto) {
            this.actualizarSeo();
            this.precargarContactos();
        }
    }

    componentWillUnmount() {
        restaurarMetaTags();
    }

    /**
     * Se traen los contactos del vendedor antes de que el comprador toque "Consulta": el
     * boton tiene que saber ya si abre el modal o linkea derecho al numero principal.
     * Preguntarlo recien en el click no sirve, porque el window.open posterior al fetch
     * cae en el bloqueador de popups.
     */
    precargarContactos = () => {
        const vendedorId = this.props.producto?.vendedor?.id;

        if (!vendedorId) {
            return;
        }

        vendedorService.precargarContactos([vendedorId], () => {
            this.setState({contactosPrecargados: true});
        });
    };

    /** Id de la publicacion: sale del slug de la URL nueva o del ?id= de la vieja. */
    idDeLaUrl = () => {
        const slug = this.props.match?.params?.slug;
        if (slug) return productoServiceTs.idDesdeSlug(slug);

        return queryString.parse(this.props.location.search).id;
    }

    /**
     * Titulo/description/og de la ficha. El prerender del backend cubre a los bots
     * que no ejecutan JS; esto es para Google (que si lo ejecuta), para el titulo de
     * la pestania y para lo que ofrece `navigator.share`.
     */
    actualizarSeo = () => {
        const {producto} = this.props;
        if (!producto || !producto.id) return;

        const titulo = [
            producto.tipoRepuesto?.nombre,
            producto.marca?.nombre,
            producto.modelo?.nombre,
            producto.version?.nombre,
            producto.anio
        ].filter(Boolean).join(' ');

        const imagenes = this.buscarImagenes(producto);
        const imagen = imagenes?.find(img => !img.type || img.type.startsWith('image'))?.url;

        actualizarMetaTags({
            titulo,
            descripcion: producto.descripcion || `${titulo} en venta en DeAutopartes.`,
            imagen: imagen && imagen.startsWith('//') ? `https:${imagen}` : imagen,
            url: window.location.origin + productoServiceTs.crearUrlProducto(producto)
        });
    }

    setLoading = (value) => {
        this.setState({loading: value});
    }

    refreshProducto = (prodId) => {
        window.scrollTo(0, 0);

        prodId = prodId ?? this.idDeLaUrl();
        const {producto} = this.props;
        if (
            producto === undefined ||
            (producto !== undefined && producto.id !== prodId)
        ) {
            this.props.buscarYSeleccionarProducto(prodId, this.setLoading);
        }

        productoServiceTs.traerDatosRepuestosBaja(prodId, this.setRepuestosBaja);
        productoServiceTs.traerProductosSimilares(prodId, this.setProductosSimilares);
        productoServiceTs.traerUltimosProductosPorVendedorByProductId(prodId, this.setOtrosProductos);
    };

    setProductosSimilares = (productosSimilares) => {
        this.setState({productosSimilares: productosSimilares});
    };

    setRepuestosBaja = (repuestosBaja) => {        
        this.setState({repuestosBaja: repuestosBaja});
    };

    setOtrosProductos = (otrosProductosVendedor) => {
        this.setState({otrosProductosVendedor: otrosProductosVendedor});
    };


    handleClose = () => {
        this.setState({showLogin: false, showAlerta: false});
    };

    loginSuccess = () => {
        // El unico lugar que manda al login desde esta ficha es "Crear alerta", asi que al
        // volver se sigue donde se estaba en vez de dejar al comprador mirando la ficha sin
        // acordarse de que habia tocado.
        this.setState({showLogin: false, showAlerta: true});
    };

    /**
     * Links de la publicacion a sus paginas de categoria: el repuesto, el repuesto para esa marca y
     * todo lo del modelo. Es el enlazado interno que conecta cada ficha con su categoria.
     */
    linksCategoria = (producto) => {
        const {tipoRepuesto, marca, modelo} = producto;
        const links = [
            {to: urlCategoria({tipoRepuesto}), texto: tipoRepuesto?.nombre},
            {to: urlCategoria({tipoRepuesto, marca}), texto: marca?.nombre},
            {
                to: modelo?.id ? urlCategoria({marca, modelo}) : undefined,
                texto: `Todo ${[marca?.nombre, modelo?.nombre].filter(Boolean).join(" ")}`,
            },
        ];

        // La baja no tiene pagina de tipo: de sus links solo queda el del modelo.
        return links.filter((l) => l.to && l.texto);
    };

    /** La categoria mas especifica, para quien cae en una publicacion que ya no esta. */
    urlCategoriaMasCercana = (producto) => {
        const links = this.linksCategoria(producto);
        return links.length ? links[Math.min(1, links.length - 1)].to : undefined;
    };

    renderMigas = (producto) => {
        const links = this.linksCategoria(producto);
        if (!links.length) return null;

        return (
            <nav className="producto__migas" aria-label="Categorías">
                <Link to="/">Inicio</Link>
                {links.map((l) => (
                    <React.Fragment key={l.to}>
                        <span aria-hidden="true">›</span>
                        <Link to={l.to}>{l.texto}</Link>
                    </React.Fragment>
                ))}
            </nav>
        );
    };

    buscarImagenes = (prod) => {
        if (prod.imagenes && prod.imagenes.length > 0) {
            return prod.imagenes;
        } else {
            if (
                !!prod.productoBaja &&
                prod.productoBaja.imagenes &&
                prod.productoBaja.imagenes.length > 0
            ) {
                return prod.productoBaja.imagenes;
            } else {
                return [{url: this.state.appName + "/images/banner-bg.jpg", type:'image/jpeg'}];
            }
        }
    };

    share = async (prod) => {
        // Siempre la URL canonica: es la que el backend prerenderiza con los og:tags,
        // asi la preview del link sale con el titulo y la foto de la publicacion.
        const url = window.location.origin + productoServiceTs.crearUrlProducto(prod);

        if (navigator.share) {
            try {
                await navigator.share({title: document.title, url});
                return;
            } catch (error) {
                // El usuario cancelo o el navegador no pudo: se cae al portapapeles.
            }
        }

        await navigator.clipboard.writeText(url);
        alertService.msg('Link copiado! Compartilo con quien mas quieras');
    };

    /**
     * Abre —o retoma— la consulta con el vendedor por esta publicación.
     *
     * <p>Es el camino que deja registro: WhatsApp saca la conversación del sitio y con eso se pierde
     * el historial, el aviso al vendedor y cualquier respaldo si después hay un problema con la
     * compra. El botón de WhatsApp sigue estando para quien lo prefiera.
     *
     * <p>Sin sesión no se puede: el hilo cuelga de un usuario. Se lo manda al login y se vuelve acá.
     */
    consultarAlVendedor = (producto) => {
        if (!authService.isAuthenticated()) {
            authService.goToLoginAndSetOnLoginSuccess(history.location.pathname + history.location.search);
            return;
        }

        this.setState({abriendoConsulta: true});
        chatService.abrirPorProducto(producto.id).then(
            (data) => {
                this.setState({abriendoConsulta: false});
                if (data?.id) history.push(`/mensajes?conversacion=${data.id}`);
            },
            (error) => {
                this.setState({abriendoConsulta: false});
                alertService.error(error?.message || "No se pudo abrir la consulta");
            }
        );
    };

    /**
     * "Avisame cuando entre uno de estos", con el auto y el repuesto de esta ficha ya elegidos.
     *
     * <p>Es la otra salida de una publicacion con precio a consultar: si el precio que le pasan
     * no cierra, al menos queda enganchado a las proximas. Sin sesion no se puede -la alerta
     * cuelga de un usuario-, asi que primero pasa por el login, igual que el listado.
     */
    crearAlerta = () => {
        if (!authService.isAuthenticated()) {
            this.setState({showLogin: true});
            return;
        }

        this.setState({showAlerta: true});
    };

    /** El producto reducido a los cuatro campos que el modal de alerta usa como default. */
    productoParaAlerta = (producto) => ({
        marca: producto?.marca?.id ? {id: producto.marca.id} : undefined,
        modelo: producto?.modelo?.id ? {id: producto.modelo.id} : undefined,
        version: producto?.version?.id ? {id: producto.version.id} : undefined,
        tipoRepuesto: producto?.tipoRepuesto?.id ? {id: producto.tipoRepuesto.id} : undefined,
    });

    render() {
        const {producto} = this.props;

        const {loading} = this.state;
        const {
            cantidad,
            repuestosBaja,
            otrosProductosVendedor,
            productosSimilares,
        } = this.state;

        return (
            <>
                <main>
                    <div className="container__dap product py-5">

                        {loading &&
                        <LoaderGeneral grabando={loading}/>
                        }

                        {producto ? (
                            <>
                                {this.renderMigas(producto)}

                                {producto.estado !== 'ACTIVA' && <div className="even-columns">
                                    <div className="product_buy-container" data-type="product">
                                        <div className="product_buy-img">
                                            <h4>
                                                Este producto no esta disponible en este momento
                                            </h4>
                                            {/* La pieza es usada y no vuelve: se ofrece la categoria
                                                en vez de dejar a la persona sin salida. */}
                                            {!!this.urlCategoriaMasCercana(producto) && (
                                                <Link to={this.urlCategoriaMasCercana(producto)}>
                                                    Ver otros repuestos parecidos
                                                </Link>
                                            )}
                                        </div>
                                    </div>
                                </div>}

                                <div className="even-columns">
                                    <div className="product_buy-container" data-type="product">
                                        <div className="product_buy-img">
                                            <CarrouselImages images={this.buscarImagenes(producto)} esListador={false}
                                                             esProductDetail={true}/>
                                        </div>
                                    </div>
                                    <div className="product_buy-container">
                                        <h2> {producto.tipoRepuesto.nombre}</h2>

                                        {/*
                                            La misma ficha, contada en mobile.

                                            La tabla de etiqueta + valor gastaba media pantalla para
                                            decir lo que se lee de corrido: marca / modelo / version /
                                            anio van en una linea sin etiquetas, el precio grande
                                            porque es el dato que se busca, y el vendedor como frase
                                            ("Vendido por X") en vez de un nombre suelto debajo de un
                                            label — asi se entiende quien es sin tener que leer la
                                            columna de la izquierda.

                                            Es un intercambio, no una duplicacion: de `small` en
                                            adelante este bloque se esconde y vuelve la tabla, que en
                                            dos columnas se lee mejor cuando hay lugar.
                                        */}
                                        <div className="product_buy-resumen">
                                            <p className="product_buy-resumen__specs">
                                                {[
                                                    producto.marca?.nombre,
                                                    producto.modelo?.nombre,
                                                    producto.version?.nombre,
                                                    producto.anio
                                                ].filter(Boolean).join(" ")}
                                            </p>

                                            {productoActions.esPrecioAConsultar(producto) ? (
                                                <p className="product_buy-resumen__precio product_buy-resumen__precio--consultar">
                                                    Precio a consultar
                                                </p>
                                            ) : producto.tipoRepuesto.nombre !==
                                            TIPO_REPUESTO.AUTO_DESARMADERO && (
                                                <p className="product_buy-resumen__precio">
                                                    {/* El tachado antes del precio, no despues: se
                                                        lee "de tanto, a tanto". */}
                                                    <PrecioTachado oferta={producto.oferta}/>
                                                    <NumberFormat
                                                        prefix={"$"}
                                                        value={precioVigente(producto)}
                                                        displayType={"text"}
                                                        thousandSeparator="."
                                                        decimalSeparator=","
                                                    />
                                                    <BadgeOferta oferta={producto.oferta}
                                                                 className="oferta__badge--inline"/>
                                                </p>
                                            )}

                                            {producto.tipoRepuesto?.nombre ===
                                            TIPO_REPUESTO.MOTOR_04 && (
                                                <p className="product_buy-resumen__incluye">
                                                    <span className="product_label">Incluye: </span>
                                                    {productoServiceTs.crearNombreMotorAsociados(producto)}
                                                </p>
                                            )}

                                            <p className="product_buy-resumen__vendedor">
                                                <FontAwesomeIcon icon="fa-solid fa-store"/>
                                                <span>
                                                    Vendido por{" "}
                                                    <Link target={"_blank"}
                                                          to={vendedorService.crearUrlTienda(producto.vendedor)}>
                                                        {nombreVendedor(producto.vendedor)}
                                                    </Link>
                                                </span>
                                            </p>
                                        </div>

                                        {/*
                                            La letra chica de la oferta va aca, entre el precio y la
                                            tabla: quien llego a la ficha ya esta decidiendo, y
                                            "termina el 30 de septiembre" o "no incluye envio" es
                                            justo lo que necesita antes de pagar. En la card no
                                            entra, y a esa altura el badge ya dijo lo unico que
                                            importaba.
                                        */}
                                        <CartelOferta oferta={producto.oferta}/>

                                        <table className="product">
                                            <tbody>
                                            {productoActions.esPrecioAConsultar(producto) ? (
                                                <tr>
                                                    <td>
                                                        <span className="product_label">Precio </span>
                                                    </td>
                                                    <td className="product_accent--main">
                                                        A consultar con el vendedor
                                                    </td>
                                                </tr>
                                            ) : producto.tipoRepuesto.nombre !==
                                            TIPO_REPUESTO.AUTO_DESARMADERO && (
                                                <tr>
                                                    <td>
                                                        <span className="product_label">Precio </span>
                                                    </td>
                                                    <td className="product_accent--main">
                                                        <PrecioTachado oferta={producto.oferta}/>
                                                        <NumberFormat
                                                            prefix={"$"}
                                                            value={precioVigente(producto)}
                                                            displayType={"text"}
                                                            thousandSeparator="."
                                                            decimalSeparator=","
                                                        />
                                                        <BadgeOferta oferta={producto.oferta}
                                                                     className="oferta__badge--inline"/>
                                                    </td>
                                                </tr>
                                            )}

                                            <tr>
                                                <td>
                                                    <span className="product_label">Marca </span>
                                                </td>
                                                <td className="product_accent--sub">
                                                    {producto.marca?.nombre}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="product_label">Modelo </span>
                                                </td>
                                                <td className="product_accent--sub">
                                                    {producto.modelo?.nombre}
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <span className="product_label">Versión </span>
                                                </td>
                                                <td className="product_accent--sub">
                                                    {producto.version?.nombre}
                                                </td>
                                            </tr>

                                            {producto.tipoRepuesto?.nombre ===
                                            TIPO_REPUESTO.MOTOR_04 && (
                                                <tr>
                                                    <td>
                                                        <span className="product_label">Incluye </span>
                                                    </td>
                                                    <td>
                                                        <small>
                                                            {productoServiceTs.crearNombreMotorAsociados(producto)}
                                                        </small>
                                                    </td>
                                                </tr>
                                            )}

                                            {producto.anio && <tr>
                                                <td>
                                                    <span className="product_label">Año</span>
                                                </td>
                                                <td className="product_accent--sub">
                                                    {producto.anio}
                                                </td>
                                            </tr>}
                                            <tr>
                                                <td>
                                                    <span className="product_label">Vendedor </span>
                                                </td>
                                                <td className="product_accent--sub">
                                                    <Link target={"_blank"}
                                                          to={vendedorService.crearUrlTienda(producto.vendedor)}>
                                                        {nombreVendedor(producto.vendedor)}
                                                    </Link>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                        {producto.tipoEnvio == TIPO_ENVIO.ENVIO_A_COORDINAR && (
                                            <div className="product_buy-delivery">
                                                <h3 className="product_label my-2">Con Envio </h3>

                                                <div>
                                                    Este producto cuenta con un envio a coordinar con el
                                                    vendedor. Si tenes alguna duda enviale una consulta
                                                    antes de comprar.
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    {/*
                                        Botonera de acciones.

                                        Dos niveles. Arriba, en una sola fila, las dos acciones de
                                        compra: "Comprar" y "Agregar al carrito" son la misma decision
                                        tomada de dos formas, no una principal y una secundaria.
                                        Abajo, las de contacto y las auxiliares — en mobile
                                        reducidas a icono (con `title`/`aria-label` para que se sigan
                                        entendiendo y para el lector de pantalla), porque cinco botones
                                        grandes apilados se llevaban una pantalla entera.

                                        De `small` en adelante los iconos recuperan la etiqueta.
                                    */}
                                    <div className="product_buy-container product_buy-acciones" data-type="product">
                                        {/*
                                            Precio a consultar: el lugar de los botones de compra
                                            lo ocupa el cartel que explica por que no estan. Sin
                                            esto la ficha quedaba con una botonera muda y no se
                                            entendia si el producto estaba agotado o que.
                                        */}
                                        {productoActions.esPrecioAConsultar(producto) && producto.estado === 'ACTIVA' && (
                                            <div className="product_buy-acciones__consultar">
                                                <p className="product_buy-acciones__consultar-texto">
                                                    Esta publicación no tiene precio publicado. Consultale al
                                                    vendedor para arreglar el precio, o creá una alerta y te
                                                    avisamos cuando entre otro igual.
                                                </p>
                                                <button className="button" type="button" data-type="primary"
                                                        onClick={this.crearAlerta}>
                                                    <FontAwesomeIcon icon="fa-solid fa-bell"/>
                                                    <span>Crear alerta</span>
                                                </button>
                                            </div>
                                        )}

                                        {(productoActions.esComprable(producto) && producto.estado === 'ACTIVA') && (
                                            <>
                                                {productoActions.hayStock(producto) ? (
                                                    <div className="product_buy-acciones__compra">
                                                        <button
                                                            className="button"
                                                            type="button"
                                                            data-type="primary"
                                                            onClick={() =>
                                                                cartService.agregarYComprar(producto)
                                                            }
                                                        >
                                                            <span>Comprar</span>
                                                        </button>
                                                        <button
                                                            className="button"
                                                            type="button"
                                                            data-type="accent"
                                                            title="Agregar al carrito"
                                                            onClick={() => cartService.agregarItem(producto)}
                                                        >
                                                            <FontAwesomeIcon icon="fa-solid fa-cart-plus" size="lg"/>
                                                            {/*
                                                                Compartiendo fila con "Comprar" no entra la
                                                                etiqueta larga sin partirse en dos lineas, asi
                                                                que en mobile va la corta.
                                                            */}
                                                            <span className="product_buy-accion__corto">Carrito</span>
                                                            <span className="product_buy-accion__largo">Agregar al carrito</span>
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <div className="product_buy-acciones__stock">
                                                        <span className="stock--no">
                                                            ¿Querés que te avisemos cuando hay stock?
                                                        </span>
                                                        <FontAwesomeIcon icon="fa-bell" size="lg"/>
                                                    </div>
                                                )}
                                            </>
                                        )}

                                        <div className="product_buy-acciones__iconos">
                                            {/*
                                                La consulta por el sitio va PRIMERA de las tres: es la que
                                                queda registrada y la que le avisa al vendedor con una
                                                notificacion. El orden es lo que la distingue — ya no el
                                                tamanio.
                                            */}
                                            {producto.vendedor?.id !== authService.getLoggedUser()?.detail?.id && (
                                                <button className="button product_buy-accion--icono" type="button"
                                                        data-type="complementary"
                                                        title="Consultar al vendedor por el sitio"
                                                        aria-label="Consultar al vendedor por el sitio"
                                                        disabled={this.state.abriendoConsulta}
                                                        onClick={() => this.consultarAlVendedor(producto)}>
                                                    <FontAwesomeIcon icon="fa-regular fa-comments" size="lg"/>
                                                    <span className="product_buy-accion__label">
                                                        {this.state.abriendoConsulta ? "Abriendo…" : "Consultar"}
                                                    </span>
                                                </button>
                                            )}

                                            {!!producto.vendedor.numeroCelular && (
                                                productoActions.tieneContactosExtra(producto) ? (
                                                    <button className="button product_buy-accion--icono" type="button"
                                                            data-type="message"
                                                            title="Consultar por WhatsApp"
                                                            aria-label="Consultar por WhatsApp"
                                                            onClick={() => this.setState({showWhatsapp: true})}>
                                                        <FontAwesomeIcon icon="fa-brands fa-whatsapp" size="lg"/>
                                                        <span className="product_buy-accion__label">WhatsApp</span>
                                                    </button>
                                                ) : (
                                                    <a className="button product_buy-accion--icono" data-type="message"
                                                       target="_blank" rel="noreferrer"
                                                       title="Consultar por WhatsApp"
                                                       aria-label="Consultar por WhatsApp"
                                                       href={productoActions.crearLinkWhatsapp(producto)}>
                                                        <FontAwesomeIcon icon="fa-brands fa-whatsapp" size="lg"/>
                                                        <span className="product_buy-accion__label">WhatsApp</span>
                                                    </a>
                                                )
                                            )}

                                            <button className="button product_buy-accion--icono" type="button"
                                                    data-type="accent"
                                                    title="Compartir la publicación"
                                                    aria-label="Compartir la publicación"
                                                    onClick={() => this.share(producto)}>
                                                <FontAwesomeIcon icon="fa-solid fa-share"/>
                                                <span className="product_buy-accion__label">Compartir</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {/*
                                    La descripcion iba pegada abajo de la foto, donde partia en dos la
                                    columna de la imagen y se leia antes que la ficha tecnica. Va al
                                    final y a todo el ancho: es texto libre y largo, y recien se
                                    entiende despues de haber visto marca, modelo y precio.
                                */}
                                {/*
                                    La plantilla del vendedor (quienes somos, horarios, envios...) va
                                    al pie de la descripcion de todas sus publicaciones. Vive en el
                                    vendedor y no en cada producto, asi que se edita una sola vez.
                                */}
                                {!!(producto.descripcion || (producto.vendedor && producto.vendedor.plantillaDescripcion)) && (
                                    <div className="product_buy-container product_buy-description">
                                        <h3 className="product_label my-2">Descripcion </h3>
                                        {[producto.descripcion, producto.vendedor && producto.vendedor.plantillaDescripcion]
                                            .filter(Boolean)
                                            .join("\n\n")}
                                    </div>
                                )}
                            </>
                        ) : (
                            <> {!loading && <h4>Producto no encontrado</h4>}</>
                        )}

                        {repuestosBaja && repuestosBaja.length > 0 && (
                            <CarrouselProductosRel
                                refreshProducto={this.refreshProducto}
                                productos={repuestosBaja}
                                nombre="Otros productos de esta baja"
                            />
                        )}

                        {otrosProductosVendedor && otrosProductosVendedor.length > 0 && (
                            <CarrouselProductosRel
                                refreshProducto={this.refreshProducto}
                                productos={otrosProductosVendedor}
                                nombre="Otros productos del vendedor"
                            />
                        )}

                        {productosSimilares && productosSimilares.length > 0 && (
                            <CarrouselProductosRel
                                refreshProducto={this.refreshProducto}
                                productos={productosSimilares}
                                nombre="Otros productos similares"
                            />
                        )}
                    </div>
                </main>

                <Modal size="md" show={this.state.showLogin} onHide={this.handleClose}>
                    <Modal.Header closeButton></Modal.Header>
                    <Modal.Body>
                        <LoginPage onSuccess={this.loginSuccess}></LoginPage>
                    </Modal.Body>
                </Modal>

                {this.state.showAlerta && !!producto && (
                    <Modal size="lg" show={this.state.showAlerta} onHide={this.handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Crear una alerta</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <AlertaModal producto={this.productoParaAlerta(producto)}
                                         handleClose={this.handleClose}/>
                        </Modal.Body>
                    </Modal>
                )}

                {this.state.showWhatsapp && !!producto && (
                    <ModalWhatsappVendedor
                        show={this.state.showWhatsapp}
                        producto={producto}
                        handleClose={() => this.setState({showWhatsapp: false})}
                    />
                )}
            </>
        );
    }
}

function mapState(state) {
    const {producto} = state.busqueda;
    return {producto};
}

const actionCreators = {
    enviarMensaje: productoActions.enviarMensaje,
    buscarYSeleccionarProducto: busquedaActions.buscarYSeleccionarProducto,
};

const connectedProductDetail = connect(mapState, actionCreators)(ProductDetail);
export {connectedProductDetail as ProductDetail};
